import Vue from 'vue';
import VueRouter from 'vue-router';
import sys from '@/services/system';
import store from '@/store';
import { httpAPI } from "@/api/httpAPI";

Vue.use(VueRouter);

const routes = [
    {
        path: '/login',
        name: 'Login',
        meta: { layout: 'login-layout', config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
        //component: () => import('@/views/global/Login.vue'),
        component: async () => {
            let response = await httpAPI({
                url: `api/references/getclientconfig`,
                method: 'GET'
            });

            let cliConf = response.data.Payload;
            store.commit('SET_CLIENT_CONFIG', cliConf);
            if (cliConf.Config === "SED")
                return import('@/views/global/LoginFullSED.vue');
            return import('@/views/global/LoginFull.vue');
        },
        //component: () => import('@/views/global/LoginFull.vue'),
        beforeEnter: (to, from, next) => {
            store.commit('SET_CURRENT_MODULE', null);
            next();
        }
    },
    {
        path: '/',
        name: 'Main',
        meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], hasModuleNav: false },
        component: () => import('@/views/global/MainPage.vue'),
        beforeEnter: (to, from, next) => {
            store.commit('SET_CURRENT_MODULE', 'main');
            next();
        }
    },
    {
        path: '/config',
        name: 'Configuration',
        meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
        component: () => import('@/views/global/configuration/Main.vue'),
        redirect: { name: 'Profile' },
        children: [
            {
                path: 'profile',
                name: 'Profile',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/global/configuration/cards/Profile.vue')
            },
            {
                path: 'documents/requisites',
                name: 'Requisites',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: [ "EDMSConfiguration" ]} },
                component: () => import('@/views/global/configuration/lists/Requisites.vue')
            },
            {
                path: 'documents/requisites-group',
                name: 'RequisitesGroup',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: [ "EDMSConfiguration" ]} },
                component: () => import('@/views/global/configuration/lists/RequisitesGroup.vue')
            },
            {
                path: 'documents/templates',
                name: 'Templates',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: [ "EDMSConfiguration" ]} },
                component: () => import('@/views/global/configuration/lists/Templates.vue')
            },
            {
                path: 'documents/templates/card',
                name: 'TemplateCard',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: [ "EDMSConfiguration" ]} },
                component: () => import('@/views/global/configuration/cards/TemplateDesignerCard.vue'),
            },
            {
                path: 'documents/workflows',
                name: 'Workflows',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: [ "EDMSConfiguration" ]} },
                component: () => import('@/views/global/configuration/lists/Workflows.vue')
            },
            {
                path: 'documents/workflows/card',
                name: 'WorkflowCard',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: [ "EDMSConfiguration" ]} },
                component: () => import('@/views/global/configuration/cards/WorkflowCard.vue')
            },
            {
                path: 'documents/nomenclatures',
                name: 'Nomenclatures',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: [ "CreateNomenclature" ]} },
                component: () => import('@/views/global/configuration/lists/Nomenclatures.vue')                
            },
            {
                path: 'documents/nomenclatures/card',
                name: 'NomenclatureCard',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: [ "CreateNomenclature" ]} },
                component: () => import('@/views/global/configuration/cards/NomenclatureCard.vue')
            },
            {
                path: 'documents/counters',
                name: 'Counters',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: [ "CreateCounter" ]} },
                component: () => import('@/views/global/configuration/lists/Counters.vue')
            },
            {
                path: 'documents/counters/card',
                name: 'CounterCard',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: [ "CreateCounter" ]} },
                component: () => import('@/views/global/configuration/cards/CounterCard.vue')
            },
            {
                path: 'documents/started-workflows',
                name: 'StartedWorkflows',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: [ "EDMSConfiguration" ]} },
                component: () => import('@/views/global/configuration/lists/StartedWorkflows.vue')
            },
            {
                path: 'documents/finished-workflows',
                name: 'FinishedWorkflows',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: [ "EDMSConfiguration" ]} },
                component: () => import('@/views/global/configuration/lists/FinishedWorkflows.vue')
            },
            {
                path: 'sandbox',
                name: 'Sandbox',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/global/configuration/cards/Sandbox.vue')
            },
        ],
        beforeEnter: (to, from, next) => {
            store.commit('SET_CURRENT_MODULE', 'config');
            next();
        }
    },
    {
        path: '/saylau',
        meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: [ "Saylau" ] } },
        component: () => import('@/views/saylau/Main.vue'),
        redirect: { name: 'ElectionParts' },
        children: [
            {
                path: 'election-parts',
                name: 'ElectionParts',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/saylau/lists/ElectionParts.vue'),
            },
            {
                path: 'election-parts/:id',
                name: 'ElectionPart',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/saylau/cards/ElectionPart.vue'),
                props: true
            },
            {
                path: 'voters',
                name: 'Voters',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/saylau/lists/Voters.vue')
            },
            {
                path: 'tmp-voters',
                name: 'TempVoters',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/saylau/lists/TempVoters.vue')
            },
            {
                path: 'on-distribution',
                name: 'VotersOnDistribution',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/saylau/lists/VotersOnDistribution.vue')   
            },
            {
                path: 'out-distribution',
                name: 'VotersOutDistribution',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/saylau/lists/VotersOutDistribution.vue')   
            },
            {
                path: 'on-actualization',
                name: 'VotersOnActualization',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/saylau/lists/VotersOnActualization.vue')   
            },
            {
                path: 'voters/:id',
                name: 'Voter',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/saylau/cards/Voter.vue'),
                props: true
            },
            {
                path: 'addresses',
                name: 'Addresses',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/saylau/lists/Addresses.vue'),
                props: true
            },
            {
                path: 'votersbyregion',
                name: 'VotersByRegion',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/saylau/lists/RepVotersByRegion.vue'),
                props: true
            },
            {
                path: 'election-parts-info',
                name: 'Reports',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/saylau/lists/Reports.vue'),
                props: true
            },
            {
                path: 'local-search',
                name: 'LocalSearch',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/saylau/lists/LocalSearch.vue'),
            },
            {
                path: 'gbdfl-search',
                name: 'GbdflSearch',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/saylau/lists/GbdflSearch.vue'),
            },
        ],
        beforeEnter: (to, from, next) => {
            store.commit('SET_CURRENT_MODULE', 'saylau');
            next();
        }
    },
    {
        path: '/meetings',
        meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: [ "CommonDocumentService" ] } },
        component: () => import('@/views/meetings/Main.vue'),
        redirect: { name: 'MeetingsCalendar' },
        children: [
            {
                path: 'meetings-list',
                name: 'MeetingsList',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/meetings/lists/Meetings.vue'),
            },
            {
                path: 'meetings-list/:id',
                name: 'Meeting',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/meetings/cards/MeetingCard.vue'),
            },
            {
                path: 'meetings-calendar',
                name: 'MeetingsCalendar',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/meetings/calendar/Meetings.vue'),
            },
            {
                path: 'meetingprotocol/:id',
                name: 'MeetingProtocolDocument',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/cards/ProtocolCard.vue'),
            },
        ],
        beforeEnter: (to, from, next) => {
            store.commit('SET_CURRENT_MODULE', 'meetings');
            next();
        }
    },
    {
        path: '/archive',
        meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: [ "Documents" ] } },
        component: () => import('@/views/archive/Main.vue'),
        children: [
            {
                path: 'documents/:year',
                name: 'ArchiveDocuments',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/archive/lists/Documents.vue'),
                props: true
            },
            {
                path: 'documents/:year/incoming/:id',
                name: 'ArchiveIncomingDocument',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/documents/IncomingCard.vue'),
                props: true
            },
            {
                path: 'documents/:year/outgoing/:id',
                name: 'ArchiveOutgoingDocument',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/documents/OutgoingCard.vue'),
                props: true
            },
            {
                path: 'documents/:year/common-outgoing/:id',
                name: 'ArchiveOutgoingDocumentCommon',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/documents/CommonOutgoingCard.vue'),
                props: true
            },
            {
                path: 'documents/:year/inner/:id',
                name: 'ArchiveInnerDocument',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/documents/InnerCard.vue'),
                props: true
            },
            {
                path: 'documents/:year/resolution/:id',
                name: 'ArchiveResolution',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/global/cards/Resolution.vue'),
                props: true
            },
            {
                path: 'documents/:year/act-item/:id',
                name: 'ArchiveActItem',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/global/cards/ActItem.vue'),
                props: true
            },
            {
                path: 'euol/:year',
                name: 'ArchiveEuol',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/archive/lists/Euol.vue'),
                props: true
            },
            {
                path: 'euol/:year/statement/:id',
                name: 'ArchiveEuolStatement',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/documents/EuolStatement.vue'),
                props: true
            },
            {
                path: 'euol/:year/answer/:id',
                name: 'ArchiveEuolAnswer',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/documents/OutgoingCard.vue'),
                props: true
            },
            {
                path: 'euol/:year/common-answer/:id',
                name: 'ArchiveEuolAnswerCommon',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/documents/CommonOutgoingCard.vue'),
                props: true
            },
            {
                path: 'euol/:year/resolution/:id',
                name: 'ArchiveEuolResolution',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/global/cards/Resolution.vue'),
                props: true
            },
        ],
        beforeEnter: (to, from, next) => {
            store.commit('SET_CURRENT_MODULE', 'archive');
            next();
        }
    },
    {
        path: '/orders',
        meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: [ "Documents", "CommonDocumentService" ] } },
        component: () => import('@/views/orders/Main.vue'),
        redirect: { name: 'MyOrdersOnExecution' },
        children: [
            {
                path: 'orders-list',
                name: 'Orders',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/lists/Orders.vue'),
                beforeEnter: (to, from, next) => {
                    store.commit('orders/SET_CURRENT_COLLECTION', 'Orders');
                    next();
                }
            },
            {
                path: 'orders-list/:id',
                name: 'ProtocolDocument',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/cards/ProtocolCard.vue'),
            },
            {
                path: 'orders-list/:protocolid/resolution/:id',
                name: 'ProtocolResolution',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/global/cards/Resolution.vue'),
                props: true
            },
            {
                path: 'act-items-list/:type',
                name: 'ActItems',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/lists/ActItems.vue'),
                props: true,
                beforeEnter: (to, from, next) => {
                    store.commit('orders/SET_CURRENT_COLLECTION', 'ActItems');
                    next();
                }
            },
            {
                path: 'act-items-favorites-list/:type',
                name: 'ActItemsFavorites',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/lists/OrdersFavorites.vue'),
                props: true,
                beforeEnter: (to, from, next) => {
                    store.commit('orders/SET_CURRENT_COLLECTION', 'ActItems');
                    next();
                }
            },
            {
                path: 'act-items-list/:type/:id',
                name: 'ProtocolActItemDocument',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/cards/ProtocolActItemCard.vue'),
                props: true,
            },
            {
                path: 'act-items-list/:type/:actitemid/resolution/:id',
                name: 'ProtocolActItemResolution',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/global/cards/Resolution.vue'),
                props: true
            },
            {
                path: 'reporting',
                name: 'Reporting',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/lists/Reporting.vue'),
                beforeEnter: (to, from, next) => {
                    store.commit('orders/SET_CURRENT_COLLECTION', 'ProtocolSvetofor');
                    next();
                }
            },
            {
                path: 'svetofor',
                name: 'ProtocolsSvetofor',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/lists/Svetofor.vue'),
                beforeEnter: (to, from, next) => {
                    store.commit('orders/SET_CURRENT_COLLECTION', 'ProtocolSvetofor');
                    next();
                }
            },
            {
                path: 'svetofor/:id',
                name: 'ProtocolActItemDocumentSvetofor',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/cards/ProtocolActItemCard.vue'),
            },
            {
                path: 'svetofor/:actitemid/resolution/:id',
                name: 'ProtocolActItemResolutionSvetofor',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/global/cards/Resolution.vue'),
                props: true
            },

            {
                path: 'protocolscompleted',
                name: 'ProtocolsCompleted',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/lists/ProtocolsCompleted.vue'),
                beforeEnter: (to, from, next) => {
                    store.commit('orders/SET_CURRENT_COLLECTION', 'ProtocolCompleted');
                    next();
                }
            },
            {
                path: 'protocolscompleted/:id',
                name: 'ProtocolActItemDocumentProtocolsCompleted',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/cards/ProtocolActItemCard.vue'),
            },
            {
                path: 'svetofor/:actitemid/resolution/:id',
                name: 'ProtocolActItemResolutionProtocolsCompleted',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/global/cards/Resolution.vue'),
                props: true
            },

            {
                path: 'protocolsremovedfromcontrol/:type',
                name: 'ProtocolsRemovedFromControl',
                props: true,
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/lists/ProtocolsRemovedFromControl.vue'),
                beforeEnter: (to, from, next) => {
                    store.commit('orders/SET_CURRENT_COLLECTION', 'ProtocolsRemovedFromControl');
                    next();
                }
            },
            {
                path: 'protocolsremovedfromcontrol/:id',
                name: 'ProtocolActItemDocumentProtocolsRemovedFromControl',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/cards/ProtocolActItemCard.vue'),
            },
            {
                path: 'protocolsremovedfromcontrol/:actitemid/resolution/:id',
                name: 'ProtocolActItemResolutionProtocolsRemovedFromControl',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/global/cards/Resolution.vue'),
                props: true
            },

            {
                path: 'protocolsbycurrentperiod',
                name: 'ProtocolsByCurrentPeriod',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/lists/ProtocolsByCurrentPeriod.vue'),
                beforeEnter: (to, from, next) => {
                    store.commit('orders/SET_CURRENT_COLLECTION', 'ProtocolsByCurrentPeriod');
                    next();
                }
            },
            {
                path: 'protocolsbycurrentperiod/:id',
                name: 'ProtocolActItemDocumentCurrentPeriod',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/cards/ProtocolActItemCard.vue'),
            },
            {
                path: 'protocolsbycurrentperiod/:actitemid/resolution/:id',
                name: 'ProtocolActItemResolutionCurrentPeriod',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/global/cards/Resolution.vue'),
                props: true
            },

            {
                path: 'protocolsbypastperiods',
                name: 'ProtocolsByPastPeriods',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/lists/ProtocolsByPastPeriods.vue'),
                beforeEnter: (to, from, next) => {
                    store.commit('orders/SET_CURRENT_COLLECTION', 'ProtocolsByPastPeriods');
                    next();
                }
            },
            {
                path: 'protocolsbypastperiods/:id',
                name: 'ProtocolActItemDocumentPastPeriod',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/cards/ProtocolActItemCard.vue'),
            },
            {
                path: 'protocolsbypastperiods/:actitemid/resolution/:id',
                name: 'ProtocolActItemResolutionPastPeriod',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/global/cards/Resolution.vue'),
                props: true
            },
            {
                path: 'onexecutioncontrollist',
                name: 'ProtocolOnExecutionControlList',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/lists/ProtocolOnTakeOffControlList.vue'),
                beforeEnter: (to, from, next) => {
                    store.commit('orders/SET_CURRENT_COLLECTION', 'OnExecutionControl');
                    next();
                }
            },
            {
                path: 'onexecutioncontrollist/:id',
                name: 'ProtocolActItemDocumentOnExecutionControl',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/cards/ProtocolActItemCard.vue'),
            },
            {
                path: 'onexecutioncontrollist/:actitemid/resolution/:id',
                name: 'ProtocolActItemResolutionOnExecutionControl',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/global/cards/Resolution.vue'),
                props: true
            },
            {
                path: 'my/orders-on-execution',
                name: 'MyOrdersOnExecution',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/lists/MyOrdersOnExecution.vue'),
                beforeEnter: (to, from, next) => {
                    store.commit('orders/SET_CURRENT_COLLECTION', 'MyOrdersOnExecution');
                    next();
                }
            },
            {
                path: 'my/orders-on-execution/:actitemid/resolution/:id',
                name: 'MyProtocolActItemResolutionOnExecution',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/global/cards/Resolution.vue'),
                props: true
            },
            {
                path: 'my/orders-on-check',
                name: 'MyOrdersOnCheck',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/lists/MyOrders.vue'),
                beforeEnter: (to, from, next) => {
                    store.commit('orders/SET_CURRENT_COLLECTION', 'MyOrdersOnCheck');
                    next();
                }
            },
            {
                path: 'my/orders-on-check/:actitemid/resolution/:id',
                name: 'MyProtocolActItemResolutionOnCheck',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/global/cards/Resolution.vue'),
                props: true
            },
            {
                path: 'my/orders-on-control',
                name: 'MyOrdersOnControl',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/lists/MyOrdersOnControl.vue'),
                beforeEnter: (to, from, next) => {
                    store.commit('orders/SET_CURRENT_COLLECTION', 'MyOrdersOnControl');
                    next();
                }
            },
            {
                path: 'my/orders-on-control/:id',
                name: 'MyOrdersOnControlProtocolActItemDocument',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/cards/ProtocolActItemCard.vue'),
                props: true,
            },
            {
                path: 'my/orders-on-control/:actitemid/resolution/:id',
                name: 'MyOrdersOnControlProtocolActItemResolution',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/global/cards/Resolution.vue'),
                props: true
            },
            {
                path: 'my/tasks-on-control',
                name: 'MyTasksOnControl',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/lists/MyOrders.vue'),
                beforeEnter: (to, from, next) => {
                    store.commit('orders/SET_CURRENT_COLLECTION', 'MyTasksOnControl');
                    next();
                }
            },
            {
                path: 'my/tasks-on-control/:actitemid/resolution/:id',
                name: 'MyTasksOnControlProtocolActItemResolution',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/global/cards/Resolution.vue'),
                props: true
            },
            {
                path: 'onprolongationlist',
                name: 'ProtocolOnProlongationList',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/lists/ProtocolOnProlongationList.vue'),
                beforeEnter: (to, from, next) => {
                    store.commit('orders/SET_CURRENT_COLLECTION', 'OnProlongation');
                    next();
                }
            },
            {
                path: 'onprolongationlist/:id',
                name: 'ProtocolActItemDocumentOnProlongation',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/cards/ProtocolActItemCard.vue'),
            },
            {
                path: 'onprolongationlist/:actitemid/resolution/:id',
                name: 'ProtocolActItemResolutionOnProlongation',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/global/cards/Resolution.vue'),
                props: true
            },

            {
                path: 'my/processes-on-extension/:id',
                name: 'ProtocolActItemDocumentOnMyExtension',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/cards/ProtocolActItemCard.vue'),
            },
            {
                path: 'my/processes-on-adjustment',
                name: 'MyProcessesOnAdjustment',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/lists/MyProcesses.vue'),
                beforeEnter: (to, from, next) => {
                    store.commit('orders/SET_CURRENT_COLLECTION', 'MyProcessesOnAdjustment');
                    next();
                }
            },
            {
                path: 'my/processes-on-adjustment/:id',
                name: 'ProtocolActItemDocumentOnMyAdjustment',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/cards/ProtocolActItemCard.vue'),
            },
            {
                path: 'my/processes-on-adjustment/:actitemid/resolution/:id',
                name: 'ProtocolActItemResolutionOnMyAdjustment',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/global/cards/Resolution.vue'),
                props: true
            },
            {
                path: 'my/orders-dashboard',
                name: 'MyOrdersDashboard',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/orders/lists/MyOrdersDashboard.vue')                
            },
        ],
        beforeEnter: (to, from, next) => {
            store.commit('SET_CURRENT_MODULE', 'orders');
            next();
        }
    },
    {
        path: '/reportsgeneration',
        meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
        component: () => import('@/views/reportsgeneration/Main.vue'),
        redirect: { name: 'AllMyReport' },
        children: [
            {
                path: 'allmyreport',
                name: 'AllMyReport',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/reportsgeneration/lists/AllMyReport.vue'),
                beforeEnter: (to, from, next) => {
                    store.commit('reportsgeneration/SET_CURRENT_COLLECTION', 'AllMyReport');
                    next();
                }
            },
            {
                path: 'allmyreport/:id',
                name: 'ReportQuery',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4 ] },
                component: () => import('@/views/reportsgeneration/cards/ReportQuery.vue'),
            },
            {
                path: 'allmyreport/reportresolution/:id',
                name: 'AllMyReportReportResolution',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4 ] },
                component: () => import('@/views/reportsgeneration/cards/ReportTask.vue'),
            },
            {
                path: 'allmyreport/reportinteraction/:queryId/:executionId',
                name: 'ReportInteraction',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4 ] },
                component: () => import('@/views/reportsgeneration/cards/ReportInteractionCard.vue'),
                props: (route) => ({ queryId: route.query.queryId, executionId: route.query.executionId, ...route.params })
            },

            {
                path: 'mycreated',
                name: 'MyCreated',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/reportsgeneration/lists/MyCreated.vue'),
                beforeEnter: (to, from, next) => {
                    store.commit('reportsgeneration/SET_CURRENT_COLLECTION', 'MyCreated');
                    next();
                }
            },
            {
                path: 'mycreated/reportresolution/:id',
                name: 'MyCreatedReportResolution',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4 ] },
                component: () => import('@/views/reportsgeneration/cards/ReportTask.vue'),
            },
            {
                path: 'myexecution',
                name: 'MyExecution',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/reportsgeneration/lists/MyExecution.vue'),
                beforeEnter: (to, from, next) => {
                    store.commit('reportsgeneration/SET_CURRENT_COLLECTION', 'MyExecution');
                    next();
                }
            },
            {
                path: 'myexecution/reportresolution/:id',
                name: 'MyExecutionReportResolution',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4 ] },
                component: () => import('@/views/reportsgeneration/cards/ReportTask.vue'),
            },
            
        ],
        beforeEnter: (to, from, next) => {
            store.commit('SET_CURRENT_MODULE', 'reportsgeneration');
            next();
        }
    },
    {
        path: '/chancellery',
        meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: ["ChancelleryIncomingDocumentsList", "ChancelleryOutcomingDocumentsList", "ChancelleryInternalDocumentsList"], strategy: "HAS_ANY" } },
        component: () => import('@/views/chancellery/Main.vue'),
        children: [
            {
                path: 'incomings',
                name: 'ChancelleryIncomings',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: ["ChancelleryIncomingDocumentsList"] } },
                component: () => import('@/views/chancellery/lists/Incomings.vue'),
                props: true
            },
            {
                path: 'outgoings',
                name: 'ChancelleryOutgoings',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: ["ChancelleryOutcomingDocumentsList"] } },
                component: () => import('@/views/chancellery/lists/Outgoings.vue'),
                props: true
            },
            {
                path: 'inners',
                name: 'ChancelleryInners',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: ["ChancelleryInternalDocumentsList"] } },
                component: () => import('@/views/chancellery/lists/Inners.vue'),
                props: true   
            },
            {
                path: 'resolutions',
                name: 'ChancelleryResolutions',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: ["ChancelleryOutcomingDocumentsList", "CanSignChancellery"] } },
                component: () => import('@/views/chancellery/lists/Resolutions.vue'),
                props: true
            },
            //Cards                          
            {
                path: 'inner/:id',
                name: 'ChancelleryInnerDocument',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/documents/InnerCard.vue'),
                props: true
            },
            {
                path: 'outgoing/:id',
                name: 'ChancelleryOutgoingDocument',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/documents/OutgoingCard.vue'),
                props: true
            },
            {
                path: 'incoming/:id',
                name: 'ChancelleryIncomingDocument',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/documents/IncomingCard.vue'),
                props: true
            },
            {
                path: 'resolution/:id',
                name: 'ChancelleryResolution',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/global/cards/Resolution.vue'),
                props: true
            },
        ],
        beforeEnter: (to, from, next) => {
            store.commit('SET_CURRENT_MODULE', 'chancellery');
            next();
        }
    },
    {
        path: '/correspondence',
        name: 'Correspondence',
        meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: ["DocumentsCorrespondence" ], requiredConfig: [ 8 ] } },
        component: () => import('@/views/correspondence/Main.vue'),
        redirect: { name: 'CorrespondenceInWork', params: { collection: 'Documents.My.OnExecution' } },
        children: [
            {
                path: 'projects/:collection',
                name: 'CorrespondenceProjects',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/correspondence/Projects.vue'),
                props: route => ({ collection: route.params.collection }),
                beforeEnter: (to, from, next) => {
                    store.commit('correspondence/SET_LIST', 'projects');
                    next();
                }
            },
            {
                path: 'inWork/:collection',
                name: 'CorrespondenceInWork',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/correspondence/InWork.vue'),
                props: route => ({ collection: route.params.collection }),
                beforeEnter: (to, from, next) => {
                    store.commit('correspondence/SET_LIST', 'inWork');
                    next();
                }
            },
            {
                path: 'handled',
                name: 'CorrespondenceHandled',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/correspondence/Handled.vue'),
                props: true,
                beforeEnter: (to, from, next) => {
                    store.commit('correspondence/SET_LIST', 'handled');
                    next();
                }
            },
            {
                path: 'incomings',
                name: 'CorrespondenceIncomings',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/correspondence/lists/Incomings.vue'),
                props: true,
                beforeEnter: (to, from, next) => {
                    store.commit('correspondence/SET_LIST', 'incomings');
                    next();
                }
            },
            {
                path: 'outgoings',
                name: 'CorrespondenceOutgoings',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/correspondence/lists/Outgoings.vue'),
                props: true,
                beforeEnter: (to, from, next) => {
                    store.commit('correspondence/SET_LIST', 'outgoings');
                    next();
                }
            },
            {
                path: 'inners/:collection',
                name: 'CorrespondenceInners',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/correspondence/lists/Inners.vue'),
                props: route => ({ collection: route.params.collection }),
                beforeEnter: (to, from, next) => {
                    store.commit('correspondence/SET_LIST', 'inners');
                    next();
                }
            },
            {
                path: 'svetofor',
                name: 'CorrespondenceSvetofor',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/correspondence/lists/Svetofor.vue'),
                props: true,
                beforeEnter: (to, from, next) => {
                    store.commit('correspondence/SET_LIST', 'svetofor');
                    next();
                }
            },
            {
                path: 'completed',
                name: 'CorrespondenceCompleted',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/correspondence/lists/Completed.vue'),
                props: true,
                beforeEnter: (to, from, next) => {
                    store.commit('correspondence/SET_LIST', 'completed');
                    next();
                }
            },
            {
                path: 'dirords',
                name: 'CorrespondenceDirords',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/correspondence/lists/Dirords.vue'),
                props: true,
                beforeEnter: (to, from, next) => {
                    store.commit('correspondence/SET_LIST', 'dirords');
                    next();
                }
            },
            {
                path: 'incomingActItems',
                name: 'CorrespondenceIncomingActItems',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/correspondence/lists/IncomingActItems.vue'),
                props: true,
                beforeEnter: (to, from, next) => {
                    store.commit('correspondence/SET_LIST', 'incomingActItems');
                    next();
                }
            },
            {
                path: 'ords/:collection',
                name: 'CorrespondenceOrds',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/correspondence/lists/Ords.vue'),
                props: route => ({ collection: route.params.collection }),
                beforeEnter: (to, from, next) => {
                    store.commit('correspondence/SET_LIST', 'ords');
                    next();
                }
            },
            {
                path: 'innerActItems',
                name: 'CorrespondenceInnerActItems',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/correspondence/lists/InnerActItems.vue'),
                props: true,
                beforeEnter: (to, from, next) => {
                    store.commit('correspondence/SET_LIST', 'innerActItems');
                    next();
                }
            },
            {
                path: 'chancelleryincomings',
                name: 'CorrespondenceChancelleryIncomings',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: ["ChancelleryIncomingDocumentsList"], requiredConfig: [ 8 ] } },
                component: () => import('@/views/chancellery/lists/Incomings.vue'),
                props: true,
                beforeEnter: (to, from, next) => {
                    store.commit('correspondence/SET_LIST', 'chancelleryincomings');
                    next();
                }
            },
            {
                path: 'chancelleryoutgoings',
                name: 'CorrespondenceChancelleryOutgoings',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: ["ChancelleryOutcomingDocumentsList"], requiredConfig: [ 8 ] } },
                component: () => import('@/views/chancellery/lists/Outgoings.vue'),
                props: true,
                beforeEnter: (to, from, next) => {
                    store.commit('correspondence/SET_LIST', 'chancelleryoutgoings');
                    next();
                }
            },
            {
                path: 'chancelleryinners',
                name: 'CorrespondenceChancelleryInners',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: ["ChancelleryInternalDocumentsList"], requiredConfig: [ 8 ] } },
                component: () => import('@/views/chancellery/lists/Inners.vue'),
                props: true,
                beforeEnter: (to, from, next) => {
                    store.commit('correspondence/SET_LIST', 'chancelleryinners');
                    next();
                }   
            },
            {
                path: 'chancelleryresolutions',
                name: 'CorrespondenceChancelleryResolutions',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: ["ChancelleryOutcomingDocumentsList", "CanSignChancellery"], requiredConfig: [ 8 ] } },
                component: () => import('@/views/chancellery/lists/Resolutions.vue'),
                props: true,
                beforeEnter: (to, from, next) => {
                    store.commit('correspondence/SET_LIST', 'chancelleryresolutions');
                    next();
                }
            },
            {
                path: ':list/:openType/:id',
                name: 'CorrespondenceListDocument',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/documents/ProxyCard.vue'),
                props: route => ({
                    list: route.params.list,
                    id: route.params.id,
                    openType: route.params.openType,
                })
            },
            {
                path: ':list/:collection/:openType/:id',
                name: 'CorrespondenceListCollectionDocument',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/documents/ProxyCard.vue'),
                props: route => ({
                    list: route.params.list,
                    collection: route.params.collection,
                    id: route.params.id,
                    openType: route.params.openType,
                })
            },
            {
                path: 'favorites',
                name: 'CorrespondenceFavorites',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/correspondence/lists/Favorites.vue'),
                // props: route => ({
                //     list: route.params.list,
                //     collection: route.params.collection,
                //     id: route.params.id,
                //     openType: route.params.openType,
                // })
            },
        ],
        beforeEnter: (to, from, next) => {
            store.commit('SET_CURRENT_MODULE', 'correspondence');
            next();
        }
    },
    {
        path: '/npa',
        name: 'NPA',
        meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4 ], access: { permissions: [ "NPA" ]} },
        component: () => import('@/views/npa/Main.vue'),
        redirect: { name: 'NPAProjectsList' },
        children: [
            {
                path: 'npa-projects-list',
                name: 'NPAProjectsList',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/npa/List.vue'),
                beforeEnter: (to, from, next) => {
                    store.commit('npa/SET_CATEGORY', '-1');
                    next();
                }
            },
            {
                path: 'npa-solutions-list',
                name: 'NPASolutionsList',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/npa/List.vue'),
                beforeEnter: (to, from, next) => {
                    store.commit('npa/SET_CATEGORY', '0');
                    next();
                }
            },
            {
                path: 'npa-resolutions-list',
                name: 'NPAResolutionsList',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/npa/List.vue'),
                beforeEnter: (to, from, next) => {
                    store.commit('npa/SET_CATEGORY', '1');
                    next();
                }
            },
            {
                path: 'npa-orders-list',
                name: 'NPAOrdersList',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/npa/List.vue'),
                beforeEnter: (to, from, next) => {
                    store.commit('npa/SET_CATEGORY', '2');
                    next();
                }
            },
            {
                path: 'npa-projects-list/:id',
                name: 'NPADocument',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/documents/NPADocumentCard.vue'),
            },
            {
                path: 'npa-solutions-list/:id',
                name: 'NPADocument0',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/documents/NPADocumentCard.vue'),
            },
            {
                path: 'npa-resolutions-list/:id',
                name: 'NPADocument1',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/documents/NPADocumentCard.vue'),
            },
            {
                path: 'npa-orders-list/:id',
                name: 'NPADocument2',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/documents/NPADocumentCard.vue'),
            },
        ],
        beforeEnter: (to, from, next) => {
            store.commit('SET_CURRENT_MODULE', 'npa');
            next();
        }
    },
    {
        path: '/eds-light',
        name: 'EdsLight',
        meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4 ], access: { permissions: [ "DocumentsCorrespondence" ], requiredConfig: [ 64 ] } },
        component: () => import('@/views/eds-light/Main.vue'),
        redirect: { name: 'EdsLightInWork' },
        children: [
            {
                path: 'incomings',
                name: 'EdsLightIncomings',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4 ] },
                component: () => import('@/views/eds-light/Incomings/Incomings.vue'),
            },
            {
                path: 'outgoings',
                name: 'EdsLightOutgoings',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4 ] },
                component: () => import('@/views/eds-light/Outgoings/Outgoings.vue'),
            },
            {
                path: 'projects',
                name: 'EdsLightProjects',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4 ] },
                component: () => import('@/views/eds-light/Projects.vue'),
            },
            {
                path: 'inners',
                name: 'EdsLightInners',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4 ] },
                component: () => import('@/views/eds-light/Inners.vue'),
            },
            {
                path: 'in-work',
                name: 'EdsLightInWork',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4 ] },
                component: () => import('@/views/eds-light/InWork.vue'),
            },
            {
                path: 'handled',
                name: 'EdsLightHandled',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4 ] },
                component: () => import('@/views/correspondence/Handled.vue'),
                props: true
            },
            {
                path: 'inner/:id',
                name: 'EdsLightInnerDocument',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4 ] },
                component: () => import('@/views/eds-light/documents/InnerCard.vue'),
                props: true
            },
            {
                path: 'outgoing/:id',
                name: 'EdsLightOutgoingDocument',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4 ] },
                component: () => import('@/views/eds-light/documents/OutgoingCard.vue'),
                props: true
            },
            {
                path: 'incoming/:id',
                name: 'EdsLightIncomingDocument',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4 ] },
                component: () => import('@/views/eds-light/documents/IncomingCard.vue'),
                props: true
            },
            {
                path: 'resolution/:id',
                name: 'EdsLightResolution',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4 ] },
                component: () => import('@/views/eds-light/documents/ResolutionCard.vue'),
                props: true
            },
        ],
        beforeEnter: (to, from, next) => {
            store.commit('SET_CURRENT_MODULE', 'eds-light');
            next();
        }
    },
    {
        path: '/qala-qyzmet',
        name: 'QalaQyzmet',
        meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ], access: { permissions: [], requiredConfig: [ 32 ] } },
        component: () => import('@/views/qala-qyzmet/Main.vue'),
        redirect: { name: 'QalaQyzmetRequests' },
        children: [
            {
                path: 'contracts',
                name: 'QalaQyzmetContracts',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/qala-qyzmet/Contracts.vue'),
            },
            {
                path: 'contracts/:id',
                name: 'QalaQyzmetContractCard',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/qala-qyzmet/cards/ContractCard.vue'),
                props: true
            },
            {
                path: 'requests',
                name: 'QalaQyzmetRequests',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/qala-qyzmet/Requests.vue'),
            },
            {
                path: 'requests/:id',
                name: 'QalaQyzmetRequestCard',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/qala-qyzmet/cards/RequestCard.vue'),
                props: true
            },
            {
                path: 'tasks',
                name: 'QalaQyzmetTasks',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/qala-qyzmet/Tasks.vue'),
            },
            {
                path: 'tasks/:id',
                name: 'QalaQyzmetOrderCard',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/qala-qyzmet/cards/OrderCard.vue'),
                props: true
            },
            {
                path: 'in-work',
                name: 'QalaQyzmetInWork',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/qala-qyzmet/InWork.vue')
            },
            {
                path: 'reception-schedule-calendar',
                name: 'ReceptionScheduleCalendar',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/qala-qyzmet/reception-schedule/Calendar.vue'),
            },
            {
                path: 'reception-schedule-list',
                name: 'ReceptionScheduleList',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/qala-qyzmet/reception-schedule/List.vue'),
            },
            {
                path: 'reception-schedule-list/:id',
                name: 'ReceptionScheduleCard',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
                component: () => import('@/views/qala-qyzmet/reception-schedule/Card.vue'),
                props: true
            },
        ],
        beforeEnter: (to, from, next) => {
            store.commit('SET_CURRENT_MODULE', 'qalaQyzmet');
            next();
        }
    },
    //Планы мероприятий
    {
        path: '/planner',
        name: 'Planner',
        meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
        component: () => import('@/views/planner/Main.vue'),
        redirect: { name: 'PlannerBoard' },
        children: [
            {
                path: 'board',
                name: 'PlannerBoard',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4 ] },
                component: () => import('@/views/planner/PlannerBoard.vue'),
                props: true
            },
            {
                path: 'planned-meeting/:id',
                name: 'PlannedMeeting',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4 ] },
                component: () => import('@/views/planner/PlannedMeeting.vue'),
                props: true
            },
            {
                path: 'indicators',
                name: 'Indicators',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4 ] },
                component: () => import('@/views/planner/Indicators.vue'),
                props: true
            },
            {
                path: 'indicator/:id',
                name: 'Indicator',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4 ] },
                component: () => import('@/views/planner/IndicatorCard.vue'),
                props: true
            },
        ],
        beforeEnter: (to, from, next) => {
            store.commit('SET_CURRENT_MODULE', 'planner');
            next();
        },
        props: true
    },
    {
        path: '/sep',
        name: 'Sep',
        meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
        component: () => import('@/views/sep/Main.vue'),
        redirect: { name: 'DynamicTableView' },
        children: [
            {
                path: 'dynamicform',
                name: 'DynamicForm',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4 ] },
                component: () => import('@/views/sep/DynamicFormView.vue'),
                props: true
            },
            {
                path: 'dynamictable/:id?',
                name: 'DynamicTableView',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4 ] },
                component: () => import('@/views/sep/DynamicTableView.vue'),
                props: true
            },
            {
                path: 'dynamictableaddrows/:id',
                name: 'DynamicTableAddRowsView',
                meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4 ] },
                component: () => import('@/views/sep/DynamicTableAddRowsView.vue'),
                props: true
            }
        ],
        beforeEnter: (to, from, next) => {
            store.commit('SET_CURRENT_MODULE', 'planner');
            next();
        },
        props: true
    },    
    {
        path: "*",
        meta: { layout: 'main-layout', authRequired: true, config: [ sys.Configurations.C4, sys.Configurations.C5 ] },
        component: () => import("@/views/global/NotFound.vue"),
        beforeEnter: (to, from, next) => {
            store.commit('SET_CURRENT_MODULE', null);
            next();
        }
    },
];

const router = new VueRouter({
    routes: routes.filter(route => route.meta.config.includes(process.env.VUE_APP_CONFIGURATION)),
});

const routeNameOpenTypes = {
    ChancelleryInnerDocument: "Chancellery|Documents.Document", 
    ChancelleryIncomingDocument: "Chancellery|Documents.Document",
    ChancelleryOutgoingDocument: "Chancellery|Documents.Document",
    ChancelleryResolution: "Documents|Orders|CitizenStatements.Resolution",

    CorrespondenceInnerDocument: "Chancellery|Documents.Document", 
    CorrespondenceIncomingDocument: "Chancellery|Documents.Document",
    CorrespondenceOutgoingDocument: "Chancellery|Documents.Document",
    CorrespondenceResolution: "Documents|Orders|CitizenStatements.Resolution",
    CorrespondenceActItem: "Documents|Orders|CitizenStatements.Resolution",
    CorrespondenceNPADocument: "Documents.NPA.Document",

    EdsLightInnerDocument: "Chancellery|Documents.Document", 
    EdsLightIncomingDocument: "Chancellery|Documents.Document",
    EdsLightOutgoingDocument: "Chancellery|Documents.Document",
    EdsLightResolution: "Documents|Orders|CitizenStatements.Resolution",

    ArchiveIncomingDocument: "Chancellery|Documents.Document",
    ArchiveOutgoingDocument: "Chancellery|Documents.Document",
    ArchiveOutgoingDocumentCommon: "Chancellery|Documents.Document",
    ArchiveInnerDocument: "Chancellery|Documents.Document",    
    ArchiveResolution: "Documents|Orders|CitizenStatements.Resolution",
    ArchiveActItem: "Documents|Orders|CitizenStatements.Resolution",
    ArchiveEuolStatement: "CitizenStatements.EuolStatement",
    ArchiveEuolAnswer: "Chancellery|Documents.Document",
    ArchiveEuolAnswerCommon: "Chancellery|Documents.Document",
    ArchiveEuolResolution: "Documents|Orders|CitizenStatements.Resolution",

    Meeting: "None.Meeting",
    ReceptionScheduleCard: "None.Reception",

    ProtocolDocument: "Chancellery|Documents.Document",
    ProtocolActItemDocument: "Chancellery|Documents.Document",
    ProtocolActItemDocumentOnExecution: "Chancellery|Documents.Document",
    ProtocolActItemDocumentOnControl: "Chancellery|Documents.Document",
    //ProtocolActItemDocumentOnAdjustment: "Chancellery|Documents.Document",
    ProtocolActItemDocumentOnExecutionControl: "Chancellery|Documents.Document",
    //ProtocolActItemDocumentOnMyControl: "Chancellery|Documents.Document",
    ProtocolActItemDocumentOnMyAdjustment: "Chancellery|Documents.Document",
    MyOrdersOnControlProtocolActItemDocument: "Chancellery|Documents.Document",
    ProtocolResolution: "Documents|Orders|CitizenStatements.Resolution",
    ProtocolActItemResolution: "Documents|Orders|CitizenStatements.Resolution",
    ProtocolActItemResolutionOnExecution: "Documents|Orders|CitizenStatements.Resolution",
    ProtocolActItemResolutionOnControl: "Documents|Orders|CitizenStatements.Resolution",
    //ProtocolActItemResolutionOnAdjustment: "Documents|Orders|CitizenStatements.Resolution",
    ProtocolActItemResolutionOnExecutionControl: "Documents|Orders|CitizenStatements.Resolution",
    MyProtocolActItemResolutionOnExecution: "Documents|Orders|CitizenStatements.Resolution",
    MyProtocolActItemResolutionOnCheck: "Documents|Orders|CitizenStatements.Resolution",
    MyTasksOnControlProtocolActItemResolution: "Documents|Orders|CitizenStatements.Resolution",
    //ProtocolActItemResolutionOnMyControl: "Documents|Orders|CitizenStatements.Resolution",
    ProtocolActItemResolutionOnMyAdjustment: "Documents|Orders|CitizenStatements.Resolution",
    MyOrdersOnControlProtocolActItemResolution: "Documents|Orders|CitizenStatements.Resolution",
    ProtocolActItemDocumentOnProlongation: "Chancellery|Documents.Document",
    ProtocolActItemDocumentSvetofor: "Chancellery|Documents.Document",
    ProtocolActItemDocumentProtocolsCompleted: "Chancellery|Documents.Document",
    ProtocolActItemDocumentProtocolsRemovedFromControl: "Chancellery|Documents.Document",
    ProtocolActItemDocumentCurrentPeriod: "Chancellery|Documents.Document",
    ProtocolActItemDocumentPastPeriod: "Chancellery|Documents.Document",
    ProtocolActItemResolutionOnProlongation: "Documents|Orders|CitizenStatements.Resolution",
    ProtocolActItemResolutionSvetofor: "Documents|Orders|CitizenStatements.Resolution",
    ProtocolActItemResolutionProtocolsCompleted: "Documents|Orders|CitizenStatements.Resolution",
    ProtocolActItemResolutionProtocolsRemovedFromControl: "Documents|Orders|CitizenStatements.Resolution",
    ProtocolActItemResolutionCurrentPeriod: "Documents|Orders|CitizenStatements.Resolution",
    ProtocolActItemResolutionPastPeriod: "Documents|Orders|CitizenStatements.Resolution",

    ReportQuery: "Documents.ReportGeneration.Query",
    MyCreatedReportResolution: "Documents|Orders|CitizenStatements.Resolution",
    MyExecutionReportResolution: "Documents|Orders|CitizenStatements.Resolution",
    ReportInteraction: "Documents.ReportGeneration.Form",
    AllMyReportReportResolution: "Documents|Orders|CitizenStatements.Resolution",

    QalaQyzmetRequestCard: "Chancellery|Documents|CitizenStatements.Document",
    QalaQyzmetContractCard: "Chancellery|Documents.Document",

    PlannedMeeting: "None.PlannedMeeting",
    Indicator: "None.Indicators.Indicator",

    NPADocument: "Documents.NPA.Document",
    NPADocument0: "Documents.NPA.Document",
    NPADocument1: "Documents.NPA.Document",
    NPADocument2: "Documents.NPA.Document"
};

const shouldUpdateSource = function(route) {
    return route.params?.fromSource !== true && routeNameOpenTypes[route.name] !== undefined;
};

router.beforeEach(async (to, from, next) => {    
    
    store.dispatch('setOverlayVisible', { visible: true, text: `Загрузка` });

    if (!store.state.global.auth.authorized) {
        if (to.matched.some((record) => record.meta.authRequired)) {
            next('/login');
        }
        else {
            next();
        }
    }
    else if (to.name === 'Login') {
        next('/');
    }
    else {
        let restrictions = to.matched.map(x => x.meta.access).filter(x => x);

        if (restrictions != null && restrictions.length > 0 && restrictions.every(r => !router.app.$validatePermission(r))) {
            next(false);
            store.dispatch('setOverlayVisible', { visible: false });
            router.app.$notify.alert("Права пользователя не соответствуют требуемым!");
        }
        else {
            store.commit('documents/toolbar/SET_MENU', { menu: [] });
            next();
            if (to.params.openType && !to.params.fromSource)
                await store.dispatch('global/actionsource/loadDataSource',
                    { 
                        id: to.params?.id,
                        openType: to.params.openType,
                        common: to.query?.common === "true" && store.getters['global/auth/isCommonServiceEnabled']
                    }, { root: true });
            else if (shouldUpdateSource(to)) {
                if (to.name == "ReportInteraction"){
                    await store.dispatch('global/actionsource/loadDataSource',
                        { 
                            id: "ShowReportForm",
                            openType: "Documents.ReportGeneration.Form",
                            params:  to.params,
                        }, { root: true });
                }
                else {
                    await store.dispatch('global/actionsource/loadDataSource',
                        { 
                            id: to.params?.id,
                            openType: routeNameOpenTypes[to.name],
                            common: to.query?.common === "true" && store.getters['global/auth/isCommonServiceEnabled']
                        }, { root: true });
                }
            }
        }
    }
});

router.afterEach(() => {
    store.dispatch('setOverlayVisible', { visible: false });
});

export default router;
